function getBrandConfigurations(programme_id) {
  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/brand-configuration`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      programme_id: programme_id,
    },
  })
    .then((response) => response.json())
    .then((responseJSON) => {
      return responseJSON;
    });
}

export default getBrandConfigurations;
